// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__EsjsF","column":"style_column__3H1tL"};